export enum APP_ENV_ENUM {
  mock = 'mock',
  dev = 'dev',
  fat = 'fat',
  uat = 'uat',
  pre = 'pre',
  pro = 'pro',
}

export type EnvData = {
  env: APP_ENV_ENUM;
  serverUrl: string;
  ubtUrl: string;
  csUrl: string;
  grouponUrl: string;
  marketUrl:string;
  rentUrl: string;
  /** 两轮网关 */
  bikeGateway: string;
}

const envConfig: Record<APP_ENV_ENUM, EnvData> = {
  mock: {
    env: APP_ENV_ENUM.mock,
    serverUrl: 'http://47.98.133.118:7300/mock/5c21e43be3b15400173b1d88',
    ubtUrl: 'https://dev-ubt.hellobike.com/yukon_logging',
    csUrl: 'https://m.hellobike.com/AppHelloBikeCSH5/dev/latest/index.html',
    grouponUrl: 'https://fat-marketingapi.hellobike.com/api?activity.groupbuy.recommendActivities',
    marketUrl: 'https://fat-marketingapi.hellobike.com',
    rentUrl: 'https://fat-a.hellobike.com/evehicle/api',
    bikeGateway: 'https://fat-bike.hellobike.com/api',
  },
  dev: {
    env: APP_ENV_ENUM.dev,
    serverUrl: 'https://newdev-api.hellobike.com/api',
    ubtUrl: 'https://dev-ubt.hellobike.com/yukon_logging',
    csUrl: 'https://m.hellobike.com/AppHelloBikeCSH5/dev/latest/index.html',
    grouponUrl: 'https://fat-marketingapi.hellobike.com/api?activity.groupbuy.recommendActivities',
    marketUrl: 'https://fat-marketingapi.hellobike.com/api',
    rentUrl: 'https://fat-a.hellobike.com/evehicle/api',
    bikeGateway: 'https://fat-bike.hellobike.com/api',
  },
  fat: {
    env: APP_ENV_ENUM.fat,
    serverUrl: 'https://fat-api.hellobike.com/api',
    ubtUrl: 'https://fat-ubt.hellobike.com/yukon_logging',
    csUrl: 'https://m.hellobike.com/AppHelloBikeCSH5/fat/latest/index.html',
    grouponUrl: 'https://fat-marketingapi.hellobike.com/api?activity.groupbuy.recommendActivities',
    marketUrl: 'https://fat-marketingapi.hellobike.com/api',
    rentUrl: 'https://fat-a.hellobike.com/evehicle/api',
    bikeGateway: 'https://fat-bike.hellobike.com/api',
  },
  uat: {
    env: APP_ENV_ENUM.uat,
    serverUrl: 'https://uat-api.hellobike.com/api',
    ubtUrl: 'https://uat-ubt.hellobike.com/yukon_logging',
    csUrl: 'https://m.hellobike.com/AppHelloBikeCSH5/uat/latest/index.html',
    grouponUrl: 'https://uat-marketingapi.hellobike.com/api?activity.groupbuy.recommendActivities',
    marketUrl: 'https://uat-marketingapi.hellobike.com/api',
    rentUrl: 'https://uat-a.hellobike.com/evehicle/api',
    bikeGateway: 'https://uat-bike.hellobike.com/api',
  },
  pre: {
    env: APP_ENV_ENUM.pre,
    serverUrl: 'https://pre-api.hellobike.com/api',
    ubtUrl: 'https://pre-ubt.hellobike.com/yukon_logging',
    csUrl: 'https://m.hellobike.com/AppHelloBikeCSH5/pre/latest/index.html',
    grouponUrl: 'https://pre-marketingapi.hellobike.com/api?activity.groupbuy.recommendActivities',
    marketUrl: 'https://pre-marketingapi.hellobike.com/api',
    rentUrl: 'https://pre-a.hellobike.com/evehicle/api',
    bikeGateway: 'https://pre-bike.hellobike.com/api',
  },
  pro: {
    env: APP_ENV_ENUM.pro,
    serverUrl: 'https://api.hellobike.com/api',
    ubtUrl: 'https://ubt.hellobike.com/yukon_logging',
    csUrl: 'https://m.hellobike.com/AppHelloBikeCSH5/latest/index.html',
    grouponUrl: 'https://marketingapi.hellobike.com/api?activity.groupbuy.recommendActivities',
    marketUrl: 'https://marketingapi.hellobike.com/api',
    rentUrl: 'https://a.hellobike.com/evehicle/api',
    bikeGateway: 'https://bike.hellobike.com/api',
  },
};
export default envConfig;
